import { render, staticRenderFns } from "./SealedUnitOverbookingStatusChip.vue?vue&type=template&id=223e2557&scoped=true&"
import script from "./SealedUnitOverbookingStatusChip.vue?vue&type=script&lang=js&"
export * from "./SealedUnitOverbookingStatusChip.vue?vue&type=script&lang=js&"
import style0 from "./SealedUnitOverbookingStatusChip.vue?vue&type=style&index=0&id=223e2557&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223e2557",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
